import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  to { transform: translateX(100%); }
`;

// FE-02: серый прямоугольник той же геометрии, что и реальный контент.
// keyframes нельзя интерполировать в объектный синтаксис (styled-components v4+),
// поэтому Bone описан tagged-template'ом.
const size = (value, fallback) => {
  const result = value ?? fallback;

  return typeof result === "number" ? `${result}px` : result;
};

export const Bone = styled.div`
  width: ${({ $width }) => size($width, "100%")};
  height: ${({ $height }) => size($height, 12)};
  margin-bottom: ${({ $mb }) => size($mb, 0)};
  border-radius: ${({ theme, $radius }) => size($radius, theme.radii.sm)};
  background-color: ${({ theme }) => theme.palette.gray[200]};
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.65), transparent);
    animation: ${shimmer} 1.4s infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;

export const Card = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(5),
  padding: theme.spacing(5),
  marginBottom: theme.spacing(4),
  borderRadius: theme.radii.lg,
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.border.main}`,

  [theme.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: theme.spacing(4),
  },
}));

export const CardMain = styled("div")(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  minWidth: 0,
}));

export const CardRoute = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(4),
}));

export const CardAside = styled("div")(({ theme }) => ({
  width: 220,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: theme.spacing(3),
  paddingLeft: theme.spacing(5),
  borderLeft: `1px solid ${theme.palette.border.light}`,

  [theme.down("sm")]: {
    width: "100%",
    paddingLeft: 0,
    paddingTop: theme.spacing(4),
    borderLeft: "none",
    borderTop: `1px solid ${theme.palette.border.light}`,
  },
}));

export const FiltersColumn = styled("div")(({ theme }) => ({
  width: 280,
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(5),
  padding: theme.spacing(5),
  borderRadius: theme.radii.lg,
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.border.main}`,
  alignSelf: "flex-start",

  [theme.down("lg")]: {
    display: "none",
  },
}));

export const Layout = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(5),
  padding: `${theme.spacing(3)}px 0`,

  [theme.down("lg")]: {
    flexDirection: "column",
  },
}));

export const List = styled("div")({
  flexGrow: 1,
  minWidth: 0,
  width: "100%",
});
